import * as React from 'react';
import { useState, createContext, useContext, useEffect } from 'react';
import { Global } from '../../Global';
import { View } from 'ol';
import TileWMS from 'ol/source/TileWMS';
import WMSServerType from 'ol/source/WMSServerType';
import { Extent } from 'ol/extent';
import TileLayer from 'ol/layer/Tile';
import Projection from 'ol/proj/Projection';

interface MapSettingsContextTyp {
  extent: Extent;
  wmsLayer: TileLayer;
  mapView: View;
  projection: Projection;
  wmsSource: TileWMS;
}

const MapSettingsContext = createContext<MapSettingsContextTyp | undefined>(
  undefined
);

type MapSettingsContextProviderProps = { children: React.ReactNode };

function MapSettingsProvider({ children }: MapSettingsContextProviderProps) {
  useEffect(() => {
    if (Global['kartstodTyp'] === 'BAS') {
      setMapView(
        new View({
          ...mapView,
          maxZoom: 11,
        })
      );
    } else if (Global['kartstodTyp'] === 'PREMIUM') {
      setMapView(
        new View({
          ...mapView,
          maxZoom: 14,
        })
      );
    }
  }, []);

  const EPSG_3006 = 'EPSG:3006';

  const wmsSource = new TileWMS({
    url: Global['wmsHost'],
    params: {
      LAYERS: 'MetriaFastighetSkarp,MetriaFastighetFinfo',
      FORMAT: 'image/png8',
      VERSION: '1.3.1',
    },
    serverType: WMSServerType.GEOSERVER,
  });

  const extent: Extent = [181896.33, 6101648.07, 964416.0, 7689478.31];

  const wmsLayer = new TileLayer({
    extent,
    className: 'ordinarie-kartlager',
    source: wmsSource,
    zIndex: 0,
  });

  const projection = new Projection({
    code: EPSG_3006,
    extent,
  });

  const [mapView, setMapView] = useState(
    new View({
      projection,
      center: [609924.45, 6877630.37],
      zoom: 2,
      maxZoom: 11,
    })
  );

  const value = {
    extent,
    wmsLayer,
    mapView,
    projection,
    wmsSource,
  };

  return (
    <MapSettingsContext.Provider value={value}>
      {children}
    </MapSettingsContext.Provider>
  );
}

function useMapSettingsContext() {
  const context = useContext(MapSettingsContext);
  if (context === undefined) {
    throw new Error('React must be used within a MapSettingsContextProvider');
  }
  return context;
}

export { MapSettingsProvider, useMapSettingsContext };
